/**
 * Referências na instrução de um job (AB#86605, task 86871): `@skill:<nome>` e
 * `@workspace:<field_name>`. Mesma regra do api (`job_mentions.ts`) e do engine.
 */
export const MENTION_PATTERN = /@(skill|workspace):([A-Za-z0-9][A-Za-z0-9_-]*)/g;

export type MentionKind = "skill" | "workspace";

export interface Mention {
  kind: MentionKind;
  key: string;
}

/** As referências da instrução, sem repetir e na ordem em que aparecem. */
export function mentionsOf(text: string): Mention[] {
  const seen = new Set<string>();
  const out: Mention[] = [];
  for (const match of text.matchAll(MENTION_PATTERN)) {
    const id = `${match[1]}:${match[2]}`;
    if (seen.has(id)) continue;
    seen.add(id);
    out.push({ kind: match[1] as MentionKind, key: match[2] });
  }
  return out;
}

/**
 * O `@` que está sendo digitado na posição do cursor, ou null. Abre a lista só
 * quando o `@` começa uma palavra — `ana@acme.com` não é referência — e fecha
 * no primeiro espaço.
 */
export function activeMention(text: string, caret: number): { start: number; query: string } | null {
  const before = text.slice(0, caret);
  const match = /(^|\s)@([A-Za-z0-9:_-]*)$/.exec(before);
  if (!match) return null;
  return { start: caret - match[2].length - 1, query: match[2] };
}

/** Troca o `@consulta` pela referência escolhida, com um espaço depois. */
export function insertMention(
  text: string,
  start: number,
  caret: number,
  mention: Mention,
): { text: string; caret: number } {
  const token = `@${mention.kind}:${mention.key} `;
  const after = text.slice(caret).replace(/^\S*/, "");
  return { text: text.slice(0, start) + token + after.replace(/^ /, ""), caret: start + token.length };
}

/** Filtra as opções pelo que já foi digitado depois do `@`, com ou sem o tipo. */
export function matchesQuery(query: string, kind: MentionKind, key: string, title?: string | null): boolean {
  const [prefix, rest] = query.includes(":") ? query.split(":", 2) : ["", query];
  if (prefix && !kind.startsWith(prefix.toLowerCase())) return false;
  const term = (rest ?? "").toLowerCase();
  if (!term) return true;
  return key.toLowerCase().includes(term) || (title ?? "").toLowerCase().includes(term);
}
